const ImageExtensions = [
  '.png', '.jpg', '.jpeg', '.svg',
  '.bmp', '.tif', '.tiff', '.gif',
];

const VideoExtensions = [
  '.mp4', '.mpeg4', '.mov', '.webm', '.qt',
  '.mpg', '.mp2', '.mpv', '.avi', '.wmv',
];

const validateFileExtension = (file, extensions = []) => {
  if (!file) return false;
  const name = file.name.toLowerCase();
  let allowed = false;
  for (let i = 0; i < extensions.length && !allowed; i += 1) {
    if (name.endsWith(extensions[i])) allowed = true;
  }
  return allowed;
};

const validateImageName = (filename) => (
  validateFileExtension({ name: filename }, ImageExtensions)
);

const validateVideoName = (filename) => (
  validateFileExtension({ name: filename }, VideoExtensions)
);

const validateImage = async (file, width, height) => {
  if (!validateFileExtension(file, ImageExtensions)) return false;
  const image = document.createElement('img');
  await new Promise((resolve) => {
    image.addEventListener('load', () => resolve());
    image.addEventListener('error', () => resolve());
    image.src = URL.createObjectURL(file);
  });
  const validSize = image.naturalWidth === width && image.naturalHeight === height;
  if (!validSize) {
    // eslint-disable-next-line no-alert
    alert(`您上傳的檔案不符合${width}X${height}的格式，請重新上傳`);
  }
  return image.naturalWidth === width && image.naturalHeight === height;
};

const validateVideo = async (file, minLength, maxLength) => {
  if (!validateFileExtension(file, VideoExtensions)) return false;

  const video = document.createElement('video');
  const duration = await new Promise((resolve) => {
    video.addEventListener('loadeddata', () => {
      resolve(video.duration);
    });
    video.src = URL.createObjectURL(file);
  });

  return duration >= minLength && duration <= maxLength;
};

export default function useValidateMedia() {
  return {
    validateImageName,
    validateVideoName,
    validateFileExtension,
    validateImage,
    validateVideo,
  };
}
